import React from "react";
import styled from "styled-components";

/*
 * Единый заголовок страницы (design-spec 03): один H1 без иконки-дубля
 * сайдбара и без отдельной карточки. `icon` принимается для совместимости и
 * намеренно не отображается.
 */
const Wrap = styled.header`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  justify-content: space-between;
  gap: 12px 24px;
  min-width: 0;
  padding: 16px 0 8px;
  @media (max-width: 767px) {
    padding-top: 8px;
  }
`;
const Title = styled.div`
  min-width: 0;
  display: grid;
  gap: 4px;
  .row {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px 12px;
    min-width: 0;
  }
  h1 {
    font-size: 28px;
    line-height: 36px;
    font-weight: 700;
    letter-spacing: -0.02em;
    color: ${(p) => p.theme.colors.text};
    overflow-wrap: anywhere;
    @media (max-width: 767px) {
      font-size: 24px;
      line-height: 32px;
    }
  }
  p {
    font-size: 15px;
    line-height: 22px;
    color: ${(p) => p.theme.colors.textSecondary};
    max-width: 70ch;
  }
`;
const Actions = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  min-width: 0;
  @media (max-width: 600px) {
    width: 100%;
    > * {
      flex: 1 1 auto;
    }
  }
`;

export default function PageHeader({
  title,
  description,
  badge,
  actions,
}: {
  /** Устарело: иконка дублировала сайдбар и больше не выводится. */
  icon?: React.ReactNode;
  title: React.ReactNode;
  description?: React.ReactNode;
  badge?: React.ReactNode;
  actions?: React.ReactNode;
}) {
  return (
    <Wrap>
      <Title>
        <div className="row">
          <h1>{title}</h1>
          {badge}
        </div>
        {description && <p>{description}</p>}
      </Title>
      {actions && <Actions>{actions}</Actions>}
    </Wrap>
  );
}
